import React from "react";
import AppPresenter from "./AppPresenter";

const AppContainer = props => <AppPresenter {...props} />;
export default AppContainer;
